<template>
  <div v-if="['AUC','REV'].indexOf(request.requestType) >-1">
    <div
      v-if="request.status === 'ACTIVE'"
      class="card"
    >
      <vue-countdown-timer
        v-if="currentTime"
        :start-time="new Date()"
        :end-time="endTime"
        :interval="1000"
        label-position="begin"
        :end-text="'Hərracın vaxtı bitmişdir'"
        :day-txt="'days'"
        :hour-txt="'hours'"
        :minutes-txt="'minutes'"
        :seconds-txt="'seconds'"
        @end_callback="getRequest"
      >
        <template
          slot="end-text"
          slot-scope="scope"
        >
          <div class="card-body bg-danger">
            <div class="lead text-white text-center">
              {{ scope.props.endText }}
            </div>
          </div>
        </template>

        <template
          slot="countdown"
          slot-scope="scope"
        >
          <div class="card-body">
            <div class="text-center text-danger lead mb-3">
              <span v-if="request.requestType === 'AUC'">{{ $t('requestCountDown.hrracnBitmTarixi') }}</span>
              <span v-else-if="request.requestType === 'REV'">{{ $t('requestCountDown.ksHrracnBitmTarixi') }}</span>
              <span v-else>{{ $t('requestCountDown.sorununBitmTarixi') }}</span>
            </div>
            <div class="justify-content-center  lead d-flex">
              <div class="text-center mr-3">
                <div class="h2">
                  <span
                    v-if="scope.props.days"
                    class="badge  bg-primary "
                  >{{
                    scope.props.days
                  }}  </span>
                </div>
                {{ $t('requestCountDown.gn') }}
              </div>
              <div class="text-center mr-3">
                <div class="h2">
                  <span class="badge bg-dark">{{ scope.props.hours }}</span>
                </div>
                {{ $t('requestCountDown.saat') }}
              </div>
              :
              <div class="text-center mr-3">
                <div class="h2">
                  <span class="badge bg-dark">{{ scope.props.minutes }}</span>
                </div>
                {{ $t('requestCountDown.dqiq') }}
              </div>
              :
              <div class="text-center mr-3">
                <div class="h2">
                  <span class="badge bg-dark">{{ scope.props.seconds }}</span>
                </div>
                {{ $t('requestCountDown.saniy') }}
              </div>
            </div>
          </div>
        </template>
      </vue-countdown-timer>
    </div>
    <div
      v-else-if="['EXPIRED','CLOSED','DISCUSSING'].indexOf( request.status)>-1"
      class="card"
    >
      <div class="card-body bg-danger">
        <div class="lead text-white text-center">
          {{ $t('requestCountDown.hrracnVaxtBitmidir') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: 'RequestCountdown',
  props: {
    request: {},
    currentTime: {}
  },
  data() {
    return {

    }
  },
  computed: {
    timeDifference() {
      return moment().valueOf() - moment(this.currentTime).valueOf();
    },
    endTime() {
      return moment(this.request.requestDeadline).add(this.timeDifference / 1000, 'seconds').format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {

    getRequest() {
      this.$emit('updateRequest')
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>